/* tslint:disable */
/* eslint-disable */
/* @relayHash 45e01b913ce25fdecab42436d8896e43 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConnectFolderQueryVariables = {
    firmMembers: Array<string | null>;
};
export type ConnectFolderQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"FolderMenu_viewer">;
    };
};
export type ConnectFolderQuery = {
    readonly response: ConnectFolderQueryResponse;
    readonly variables: ConnectFolderQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "firmMembers",
    "type": "[String]!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ConnectFolderQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FolderMenu_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ConnectFolderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolios",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              },
              {
                "kind": "Literal",
                "name": "portfolioTypes",
                "value": [
                  "FOLDER"
                ]
              },
              {
                "kind": "Literal",
                "name": "sortBy",
                "value": "MODIFIED"
              },
              {
                "kind": "Variable",
                "name": "userIds",
                "variableName": "firmMembers"
              }
            ],
            "concreteType": "PortfoliosConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfoliosEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serviceId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstItemImage",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "large"
                          }
                        ],
                        "storageKey": "firstItemImage(size:\"large\")"
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPublic",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalResults",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ConnectFolderQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/ConnectFolderQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '9a077cc1ee8434c8aae4cc476f8575f0';
export default node;
